import request from 'axios';
import 'whatwg-fetch';
import cookie from 'react-cookie';

export const GET_USER = 'GET_USER';
export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGOUT = 'LOGOUT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const WHO_AM_I = 'WHO_AM_I';
export const WHO_AM_I_SUCCESS = 'WHO_AM_I_SUCCESS';
export const SET_SLUG_VISIBLE = 'SET_SLUG_VISIBLE';
export const LOAD_TRANSLATIONS = 'LOAD_TRANSLATIONS';
export const LOAD_TRANSLATIONS_SUCCESS = 'LOAD_TRANSLATIONS_SUCCESS';
export const LOAD_TRANSLATIONS_FAILURE = 'LOAD_TRANSLATIONS_FAILURE';
export const GET_ORDERS = 'GET_ORDERS';
export const GET_ORDERS_REQUEST = 'GET_ORDERS_REQUEST';
export const GET_ORDERS_SUCCESS = 'GET_ORDERS_SUCCESS';
export const GET_ORDERS_FAILURE = 'GET_ORDERS_FAILURE';
export const GET_SEO = 'GET_SEO';
export const GET_SEO_REQUEST = 'GET_SEO_REQUEST';
export const GET_SEO_SUCCESS = 'GET_SEO_SUCCESS';
export const GET_SEO_FAILURE = 'GET_SEO_FAILURE';
export const SUBSCRIBE = 'SUBSCRIBE';
export const SUBSCRIBE_REQUEST = 'SUBSCRIBE_REQUEST';
export const SUBSCRIBE_SUCCESS = 'SUBSCRIBE_SUCCESS';
export const SUBSCRIBE_FAILURE = 'SUBSCRIBE_FAILURE';
export const CHECK_REDIRECT = 'CHECK_REDIRECT';
export const CHECK_REDIRECT_REQUEST = 'CHECK_REDIRECT_REQUEST';
export const CHECK_REDIRECT_SUCCESS = 'CHECK_REDIRECT_SUCCESS';
export const CHECK_REDIRECT_FAILURE = 'CHECK_REDIRECT_FAILURE';
export const SET_SUBSCRIBE_RESULT = 'SET_SUBSCRIBE_RESULT';
export const SEND_REVIEW = 'SEND_REVIEW';
export const SEND_REVIEW_REQUEST = 'SEND_REVIEW_REQUEST';
export const SEND_REVIEW_SUCCESS = 'SEND_REVIEW_SUCCESS';
export const SEND_REVIEW_FAILURE = 'SEND_REVIEW_FAILURE';
export const SET_REVIEW_RESULT = 'SET_REVIEW_RESULT';
export const VALIDATE_MESSAGE = 'VALIDATE_MESSAGE';
export const SEND_EMAIL = 'SEND_EMAIL';
export const SEND_MESSAGE = 'SEND_MESSAGE';
export const SEND_MESSAGE_REQUEST = 'SEND_MESSAGE_REQUEST';
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_FAILURE = 'SEND_MESSAGE_FAILURE';
export const SEND_CUSTOM_TOUR = 'SEND_CUSTOM_TOUR';
export const SEND_CUSTOM_TOUR_REQUEST = 'SEND_CUSTOM_TOUR_REQUEST';
export const SEND_CUSTOM_TOUR_SUCCESS = 'SEND_CUSTOM_TOUR_SUCCESS';
export const SEND_CUSTOM_TOUR_FAILURE = 'SEND_CUSTOM_TOUR_FAILURE';
export const GET_CURRENCY = 'GET_CURRENCY';
export const GET_CURRENCY_REQUEST = 'GET_CURRENCY_REQUEST';
export const GET_CURRENCY_SUCCESS = 'GET_CURRENCY_SUCCESS';
export const GET_CURRENCY_FAILURE = 'GET_CURRENCY_FAILURE';
export const ORDER_TOUR_GET = 'ORDER_TOUR_GET';
export const ORDER_TOUR_GET_REQUEST = 'ORDER_TOUR_GET_REQUEST';
export const ORDER_TOUR_GET_SUCCESS = 'ORDER_TOUR_GET_SUCCESS';
export const SELECT_MEANING = 'SELECT_MEANING';
export const TOGGLE_MENU = 'TOGGLE_MENU';
export const TOGGLE_CONTACTS = 'TOGGLE_CONTACTS';
export const TOGGLE_DISCOUNT = 'TOGGLE_DISCOUNT';
export const TOGGLE_FEEDBACK = 'TOGGLE_FEEDBACK';
export const TOGGLE_REVIEWS_POPUP = 'TOGGLE_REVIEWS_POPUP';
export const TOGGLE_REVIEW = 'TOGGLE_REVIEW';
export const TOGGLE_SUBSCRIBE = 'TOGGLE_SUBSCRIBE';
export const TOGGLE_COOKIES_POLICY = 'TOGGLE_COOKIES_POLICY';
export const TOGGLE_SHARE = 'TOGGLE_SHARE';
export const TOGGLE_VIDEO = 'TOGGLE_VIDEO';
export const TOGGLE_LANG_SELECT = 'TOGGLE_LANG_SELECT';
export const TEXT_SEARCH = 'TEXT_SEARCH';
export const TEXT_SEARCH_REQUEST = 'TEXT_SEARCH_REQUEST';
export const TEXT_SEARCH_SUCCESS = 'TEXT_SEARCH_SUCCESS';
export const TEXT_SEARCH_FAILURE = 'TEXT_SEARCH_FAILURE';
export const CHANGE_SEARCH_QUERY = 'CHANGE_SEARCH_QUERY';
export const CLEAR_SEARCH_RESULTS = 'CLEAR_SEARCH_RESULTS';
export const TOGGLE_LOGIN = 'TOGGLE_LOGIN';
export const SELECT_CURRENCY = 'SELECT_CURRENCY';
export const SET_MESSAGE_RESULT = 'SET_MESSAGE_RESULT';
export const SET_CUSTOM_TOUR_RESULT = 'SET_CUSTOM_TOUR_RESULT';
export const SET_LOGIN_RESULT = 'SET_LOGIN_RESULT';
export const CHANGE_REVIEW_RATING = 'CHANGE_REVIEW_RATING';
export const HOVER_RATING = 'HOVER_RATING';
export const SELECT_DISCOUNT = 'SELECT_DISCOUNT';
export const SHOW_ABOUT_VIDEO = 'SHOW_ABOUT_VIDEO';
export const LOAD_FACEBOOK_COUNT = 'LOAD_FACEBOOK_COUNT';
export const LOAD_FACEBOOK_COUNT_REQUEST = 'LOAD_FACEBOOK_COUNT_REQUEST';
export const LOAD_FACEBOOK_COUNT_SUCCESS = 'LOAD_FACEBOOK_COUNT_SUCCESS';
export const CLOSE_FACEBOOK = 'CLOSE_FACEBOOK';
export const INIT_FACEBOOK = 'INIT_FACEBOOK';
export const COUNTRY_GET = 'COUNTRY_GET';
export const COUNTRY_GET_SUCCESS = 'COUNTRY_GET_SUCCESS';
export const COUNTRY_GET_REQUEST = 'COUNTRY_GET_REQUEST';
export const CHANGE_CUSTOM_TOUR = 'CHANGE_CUSTOM_TOUR';
export const CHANGE_PATH = 'CHANGE_PATH';
export const COMPLETE_REDIRECT = 'COMPLETE_REDIRECT';





let apiUrl = '';
let mode = 'production';
let cdnApi = {};

if(process.env.NODE_ENV != 'production'){
  apiUrl = 'http://api.bn.local/';
 apiUrl = 'https://a.baikalnatu.re/';

  cdnApi = {
    'ru': 'http://api.bn.local',
    'en': 'http://api.bn.local',
    'fr': 'http://api.bn.local'
  };
  mode = 'development';
}else{
  apiUrl = 'https://a.baikalnatu.re/';

  cdnApi = {
    'ru': 'https://a.baikalnatu.re/ru',
    'en': 'https://a.baikalnatu.re/en',
    'fr': 'https://a.baikalnatu.re/fr'
  };
  mode = 'production';
}


if(process.env.NODE_API == 'cdn'){
  mode = 'development';
}else{
  mode = 'production';
}


let isCDN = (process.env.API_CDN)?true:false;

function getApiUrl(lang) {

  return cdnApi[lang];

}


export function getUser(value) {
  return {
    type: GET_USER,
    payload: value
  };
}

export function changeCustomTour(form) {
  return {
    type: CHANGE_CUSTOM_TOUR,
    payload: form
  };
}



export function fetchCountry() {
  return (dispatch, getState) => {
    let lang = getState().user.lang;
    return dispatch(loadCountry(lang));
  }
}


export function loadCountry(lang) {
  return {
    type: COUNTRY_GET,
    promise: request.get(apiUrl + lang + '/geo/country', {withCredentials: true})
  }
}



export function loadSEO(url, lang) {
  return {
    type: GET_SEO,
    promise: request.get(apiUrl + 'seo/page/' + url),
    payload: url
  }
}


export function fetchSEO(url) {
  return (dispatch, getState) => {
    let lang = getState().user.lang;
    return dispatch(loadSEO(url, lang));
  }
}



export function login(login, password) {
  return {
    type: LOGIN,
    promise: fetch(apiUrl + 'rpc/login', {method: 'POST', body: JSON.stringify({email: login, password: password}), credentials: 'include'})
  }
}


export function sendMessage(params) {
    return function(dispatch) {

        let objParams = Object.assign({}, params);

        let text =
            ((objParams.tour) ? "Тур: " + objParams.tour.title + "\n" : "") +
            ((objParams.link) ? "Ссылка на тур: " + '<a href="' + objParams.link + '" target="_blank">' + objParams.tour.title + '</a>' + "\n" : "") +
            ((objParams.departure) ? "Отправление: " + objParams.departure.start_moment.utc().format('DD.MM.YYYY ') + "\n" : "") +
            "Имя: " + objParams.firstName + "\n" +
            "Фамилия: " + objParams.lastName + "\n" +
            "Email: " + objParams.email + "\n" +
            "Телефон: " + objParams.phone + "\n" +
            "Сообщение: " + params.text + "\n"
        ;


        objParams.text = text;

        delete objParams.tour;
        delete objParams.departure;

        let data = new FormData();
        for (name in objParams) {
            data.append(name, objParams[name]);
        }

        dispatch(sendEmail(objParams));
        dispatch(sendRequest(data));
    }
}



export function sendEmail(data) {
    return {
      type: SEND_EMAIL,
      promise: request.post('/api/feedback', data)
  }
}


export function validateMessage(data) {
    return {
      type: VALIDATE_MESSAGE,
      payload: data
  }
}

export function sendRequest(data) {
  return {
    type: SEND_MESSAGE,
    promise: fetch(apiUrl + 'crm/request', {method: 'POST', body: data, credentials: 'include'})
  }
}

export function sendCustomRequest(data) {
    return {
        type: SEND_CUSTOM_TOUR,
        promise: fetch(apiUrl + 'crm/request', {method: 'POST', body: data, credentials: 'include'})
    }
}

export function sendCustomTour(objParams) {
    return function(dispatch) {

        let data = new FormData();
        for(let name in objParams) {
            data.append(name, objParams[name]);
        }

        dispatch(sendEmail(objParams));
        dispatch(sendCustomRequest(data));
    }
}


export function subscribe(params) {

  let data = new FormData();
  for(name in params) {
    data.append(name, params[name]);
  }
  return {
    type: SUBSCRIBE,
    promise: fetch(apiUrl + 'crm/member', {method: 'POST', body: data, credentials: 'include'})
  }
}

export function sendReview(params) {

  let data = new FormData();
  for(name in params) {
    data.append(name, params[name]);
  }
  return {
    type: SEND_REVIEW,
    promise: fetch(apiUrl + 'feedback', {method: 'POST', body: data, credentials: 'include'})
  }
}



export function changeReviewRating(rating) {
  return {
    type: CHANGE_REVIEW_RATING,
    payload: rating
  }
}
export function hoverRating(rating) {
  return {
    type: HOVER_RATING,
    payload: rating
  }
}


export function logout() {
  return {
    type: LOGOUT,
    promise: fetch(apiUrl + 'rpc/logout', {method: 'POST', credentials: 'include'})
  }
}



export function whoAmI() {

  return {
    type: WHO_AM_I
  //  promise: request({url: apiUrl + 'rpc/who-am-i', method: 'post', params: {}, withCredentials: true})

  }

}



export function loadTranslations(lang, host) {

  if(process.env.NODE_ENV != 'production'){
    return {
      type: LOAD_TRANSLATIONS,
      promise: request({url: getApiUrl(lang) + '/translations', method: 'get', params: {}, withCredentials: true})
    }
  } else {
    return {
      type: LOAD_TRANSLATIONS,
      promise: request({url: getApiUrl(lang) + '/translations', method: 'get', params: {}, withCredentials: true})
    }
  }
}

export function preloadTranslations() {
  return (dispatch, getState) => {
      let state = getState();
      return dispatch(loadTranslations(state.user.lang, state.user.host));
  };
}

export function whoAmISuccess() {
  return {
    type: WHO_AM_I_SUCCESS

  }
}

export function showAboutVideo() {
  return {
    type: SHOW_ABOUT_VIDEO

  }
}


export function setLoginResult(result) {
  return {
    type: SET_LOGIN_RESULT,
    payload: result
  }
}



export function changePath(path) {
  return {
    type: CHANGE_PATH,
    payload: path
  }
}



export function completeRedirect() {
  return {
    type: COMPLETE_REDIRECT
  }
}


export function checkRedirect(path, lang) {
  return {
    type: CHECK_REDIRECT,
    promise: request.get(path, {withCredentials: true}),
    payload: {lang: lang, path: path}
  }
}



export function setMessageResult(result) {
  return {
    type: SET_MESSAGE_RESULT,
    payload: result
  }
}


export function setCustomTourResult(result) {
  return {
    type: SET_CUSTOM_TOUR_RESULT,
    payload: result
  }
}


export function setSubscribeResult(result) {
  return {
    type: SET_SUBSCRIBE_RESULT,
    payload: result
  }
}


export function setReviewResult(result) {
  return {
    type: SET_REVIEW_RESULT,
    payload: result
  }
}

export function selectMeaning(index) {
  return {
    type: SELECT_MEANING,
    payload: index
  }
}

export function toggleMenu(close) {
  return {
    type: TOGGLE_MENU,
    payload: close
  }
}

export function toggleContacts() {
  return {
    type: TOGGLE_CONTACTS
  }
}


export function toggleVideo() {
  return {
    type: TOGGLE_VIDEO
  }
}


export function toggleLogin() {
  return {
    type: TOGGLE_LOGIN
  }
}

export function toggleDiscount() {
  return {
    type: TOGGLE_DISCOUNT
  }
}

export function toggleFeedback(tour, departure) {
  return {
    type: TOGGLE_FEEDBACK,
    payload: {tour: tour, departure: departure}
  }
}

export function toggleReviewsPopup() {
  return {
    type: TOGGLE_REVIEWS_POPUP
  }
}

export function toggleReview() {
  return {
    type: TOGGLE_REVIEW
  }
}

export function toggleSubscribe() {
  return {
    type: TOGGLE_SUBSCRIBE
  }
}

export function toggleCookiesPolicy() {
  return {
    type: TOGGLE_COOKIES_POLICY
  }
}

export function toggleShare() {
  return {
    type: TOGGLE_SHARE
  }
}

export function toggleLangSelect() {
  return {
    type: TOGGLE_LANG_SELECT
  }
}

export function closeFacebook() {
  cookie.save('closeFacebook', true, {path: '/', maxAge: 86400});

  return {
    type: CLOSE_FACEBOOK
  }
}


export function initFacebook() {
  return {
    type: INIT_FACEBOOK
  }
}

export function selectCurrency(currency) {
  cookie.save('currency', currency, {path: '/', maxAge: 10000000000});

  return {
    type: SELECT_CURRENCY,
    payload: currency
  }
}


export function setSlugVisible(visible) {
  return {
    type: SET_SLUG_VISIBLE,
    payload: visible
  }
}

export function selectDiscount(discount) {
  return {
    type: SELECT_DISCOUNT,
    payload: discount
  }
}


export function loadOrders(id) {
  return {
  type: GET_ORDERS,
    promise: request.get(apiUrl + 'user/' + id + '/order', {withCredentials: true})
  }
}


export function loadCurrency() {

  let apiUrl = 'https://a.baikalnatu.re/';
  return {
  type: GET_CURRENCY,
    promise: request.get(apiUrl + 'shop/currency', {withCredentials: true})
  }
}



export function loadFacebookCount() {

  let url = 'https://graph.facebook.com/v2.9/me?fields=fan_count&access_token=EAACEdEose0cBANEz7a2AI186M0O98LfTEa3uuVjxvrztRjJEhe9FTSf5ZAdRd7rZBqb7ZBQZAhIXPHXyZCATMelkfZCkTJF464ZAcARBrcAuEhskmpWI9BA2KYNXbzHAhfquyZAGFMOtMMHWZBgkWxwPZC7TzXYFei9igAQSxtUPuDzhcAcQRxYyHYATgra7j8k3IZD';
  return {
  type: LOAD_FACEBOOK_COUNT,
    promise: fetch(url, {method: 'GET', credentials: 'include'})
  }
}


export function fetchOrders() {
  return (dispatch, getState) => {
    let id = getState().user.id;
    return dispatch(loadOrders(id));
  }
}




export function loadTour(id, index, lang) {

  return {
    type: ORDER_TOUR_GET,
    promise: request.get(apiUrl + lang + '/tour/' + id),
    payload: index
  }
}



export function fetchTour(id, index) {
  return (dispatch, getState) => {
    let lang = getState().user.lang;
    return dispatch(loadTour(id, index, lang));
  }
}



function shouldFetchWhoAmI(state) {
  const user = state.user;
  if (!user) {
    return true;
  } else if (user.isFetching) {
    return false;
  } else {
    return user.didInvalidate;
  }
}

export function fetchWhoAmIIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchWhoAmI(getState())) {
      return dispatch(whoAmI());
    }
  };
}






export function loadTextSearch(text, lang) {

  return {
    type: TEXT_SEARCH,
    promise: request.get('https://a.baikalnatu.re/' + lang + '/search?q=' + text)
  }
}



export function textSearch(text) {
  return (dispatch, getState) => {
    let lang = getState().user.lang;
    return dispatch(loadTextSearch(text, lang));
  }
}



export function changeSearchQuery(query) {
  return {
    type: CHANGE_SEARCH_QUERY,
    payload: query
  }
}

export function clearSearchResults() {
  return {
    type: CLEAR_SEARCH_RESULTS
  }
}





// WEBPACK FOOTER //
// ./src/common/actions/user.js